import api from '../config/axios';

export const getLeadReport = (params) => api.get('/reports/leads', { params });
export const getDisbursementReport = (params) => api.get('/reports/disbursement', { params });
export const getSlaReport = (params) => api.get('/reports/sla', { params });
